import { createContext, useContext } from "react";

export const SettingsDensityContext = createContext<"default" | "compact">(
  "default",
);

export function useCompactSettings() {
  return useContext(SettingsDensityContext) === "compact";
}
